import { useMemo } from 'react';

import { useAppointmentTypeTemplates } from './useAppointmentTypeTemplates';

/**
 * Map of template_id → display_name for quick note-template label lookups.
 */
export const useTemplateNameById = (options?: { skip?: boolean }): Map<string, string> => {
  const templatesList = useAppointmentTypeTemplates(options);

  return useMemo(
    () =>
      new Map(
        templatesList
          .filter(template => template.display_name)
          .map(template => [template.template_id, template.display_name as string]),
      ),
    [templatesList],
  );
};
